<ng-template [ngIf]="state === 'progress' || state === 'default'">
  <on-ui-button [state]="state"
                [disabled]="disabled"
                class="secondary"
                [label]="startLabel"
                (click)="onStart()">
  </on-ui-button>

  <ng-container *ngTemplateOutlet="protected"></ng-container>
</ng-template>

<ng-template [ngIf]="state === 'done'">
  <on-ui-button class="secondary"
                [label]="closeLabel"
                (onclick)="onCancel()">
  </on-ui-button>
  <ng-container *ngTemplateOutlet="protected"></ng-container>
</ng-template>

<ng-template [ngIf]="state === 'fail'">
<!--  <on-ui-button class="primary outline margin-right"
                [label]="cancelLabel"
                (onclick)="onCancel()">
  </on-ui-button>-->
  <on-ui-button class="secondary"
                [label]="cancelLabel"
                (onclick)="onCancel()">
  </on-ui-button>
</ng-template>

<ng-template #protected>
  <div class="protected-label" [class.web]="!deviceService.isMobile()">
    <app-icon width="26" height="23" icon="protected"></app-icon>
    <div class="label">{{'lingo2-forms.pretected-payment' | translate}}</div>
  </div>
</ng-template>

